import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { getArchiveStatusSubdiv, createArchiveSubdiv as createArchiveApi } from '../../../apis';
import { loadingOperations } from '../loading';
import { getLogger } from '../../../utils';
import { systemStateMessageOperations } from '..';

const getStatus = ({ koujiBangou }
      : { koujiBangou: string; }) => async (dispatch: Dispatch<Action<any>>) => {
  try {
    const result = await getArchiveStatusSubdiv({ koujiBangou, key: 'ALL_DATA' });
    dispatch(actions.getStatus.done({ params: { koujiBangou }, result: { Item: result }}));
  } catch (error) {
    dispatch(actions.getStatus.failed({ params: { koujiBangou }, error: error.toString() }));
    getLogger().error('fullArchiveDownloadSubdiv/getStatus()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}

const createArchive = ({ koujiBangou }
      : { koujiBangou: string; }) => async (dispatch: Dispatch<Action<any>>) => {
  try {
    // ファイル作成要求は非同期にして結果をまたない
    createArchiveApi({ koujiBangou });
    dispatch(actions.createArchive.done({ params: { koujiBangou }, result: { }}));
  } catch (error) {
    dispatch(actions.createArchive.failed({ params: { koujiBangou }, error: error.toString() }));
    getLogger().error('fullArchiveDownloadSubdiv/createArchive()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  }
}



export {
  getStatus,
  createArchive
};



// WEBPACK FOOTER //
// ./src/redux/modules/fullArchiveDownloadSubdiv/operations.ts